import React from 'react';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import moment from 'moment';
import {
  Time,
  TIME_FORMAT_HOUR,
} from '../../../components/Time';
import { formatMessage } from '../../lib/intl';

const i18n = defineMessages({
  title: {
    id: 'expiryWarning.noPayments.title',
    defaultMessage: 'Deadline',
  },
});

const ExpiryWarningNoPayments = (props) => {
  const { nextPaymentDueDeadline, merchantName, intl } = props;
  const dateString = <Time time={nextPaymentDueDeadline} />;
  const timeString = <Time format={TIME_FORMAT_HOUR} time={nextPaymentDueDeadline} timezone={moment.tz.guess()} />;

  return (
    <div>
      <strong className="d-block mb-2">{formatMessage(intl)(i18n.title)}</strong>
      <FormattedMessage
        id='expiryWarning.noPayments.text'
        defaultMessage="After {dateString} {timeString}, you will not be able to make this purchase
          without a special exception from {merchantName}. The inventory is not reserved
          until you click “Make Purchase” to submit your group’s payment."
        values={{ dateString, timeString, merchantName }}
      />
    </div>
  );
}

export default injectIntl(ExpiryWarningNoPayments);



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/expiry-warning.no-payments.js